module.exports = __webpack_public_path__ + "static/diy-2110c9e933d519a5c1db55dc3a6ecb87.jpg";